module.exports = __webpack_public_path__ + "static/media/loader.a4da119e.gif";